import { DataLabel } from '@fourthwall/module-analytics';
import lowerCase from 'lodash-es/lowerCase';
import startCase from 'lodash-es/startCase';
import React from 'react';
import FacebookIcon from '../assets/facebook.svg';
import InstagramIcon from '../assets/instagram.svg';
import TikTokIcon from '../assets/tiktok.svg';
import TwitchIcon from '../assets/twitch.svg';
import XIcon from '../assets/x.svg';
import YoutubeIcon from '../assets/youtube.svg';
export const socialSourceIcons = {
    FACEBOOK: FacebookIcon,
    INSTAGRAM: InstagramIcon,
    YOUTUBE: YoutubeIcon,
    TIKTOK: TikTokIcon,
    TWITCH: TwitchIcon,
    X: XIcon,
};
export const getSocialSourceLabel = (item) => (React.createElement(DataLabel, { label: startCase(lowerCase(item.source)), icon: {
        src: item.source in socialSourceIcons ? socialSourceIcons[item.source] : undefined,
        width: 32,
        aspectRatio: 46 / 32,
    } }));
